import styled from 'styled-components'

export const StyledBingoCardPage = styled.div`
  display: flex;
  justify-content: center;
  overflow: auto;
`
